import { render, staticRenderFns } from "./legacyData.vue?vue&type=template&id=3989ce65&scoped=true"
import script from "./legacyData.vue?vue&type=script&lang=js"
export * from "./legacyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3989ce65",
  null
  
)

export default component.exports